'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_JoinGeneralPracticeRequest$$anon$3() {
}
export { $c_Lapp_api_JoinGeneralPracticeRequest$$anon$3 as $c_Lapp_api_JoinGeneralPracticeRequest$$anon$3 };
$c_Lapp_api_JoinGeneralPracticeRequest$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lapp_api_JoinGeneralPracticeRequest$$anon$3.prototype.constructor = $c_Lapp_api_JoinGeneralPracticeRequest$$anon$3;
/** @constructor */
function $h_Lapp_api_JoinGeneralPracticeRequest$$anon$3() {
}
export { $h_Lapp_api_JoinGeneralPracticeRequest$$anon$3 as $h_Lapp_api_JoinGeneralPracticeRequest$$anon$3 };
$h_Lapp_api_JoinGeneralPracticeRequest$$anon$3.prototype = $c_Lapp_api_JoinGeneralPracticeRequest$$anon$3.prototype;
$c_Lapp_api_JoinGeneralPracticeRequest$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lapp_api_JoinGeneralPracticeRequest$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lapp_api_JoinGeneralPracticeRequest$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_JoinGeneralPracticeRequest$$anon$3, "app.api.JoinGeneralPracticeRequest$$anon$3", ({
  Lapp_api_JoinGeneralPracticeRequest$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_JoinGeneralPracticeRequest$$anon$3 as $d_Lapp_api_JoinGeneralPracticeRequest$$anon$3 };
//# sourceMappingURL=app.api.-Join-General-Practice-Request$$anon$3.js.map
